var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"panel"},[_c('h1',[_vm._v("Network Issue")]),_c('router-link',{attrs:{"to":'/'}},[_vm._v("Back to the home page")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }